import { Container, Box } from '@mui/material';

function About() {
    return (
        <>
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <h1 className='pp-1'>
                    About Us
                </h1>

                <Box mt={3}>
                    <p className='pp-3'>
                        No matter your level of experience with blockchain, NVXO Wallet makes it easy to engage with the decentralized web, often called the next evolution of the internet. NVXO is a multi-chain, self-custody cryptocurrency wallet that also serves as a gateway to thousands of Web3 decentralized applications (dApps).
                    </p>
                    <p className='pp-3'>
                        Trusted by millions worldwide, our goal is to make this new decentralized web accessible to everyone.
                    </p>
                </Box>

                <Box mt={3}>
                    <p className='pp-3'>
                        NVXO Wallet operates as both a wallet and a browser, allowing users to manage their digital assets with ease. You can send and spend your assets, make global payments, and securely log into websites to participate in activities like trading, lending, borrowing, gaming, content creation, purchasing rare digital art, and more.
                    </p>
                </Box>

                <Box mt={3}>
                    <p className='pp-3'>
                        With NVXO Wallet, your keys and assets are always under your control:
                    </p>
                    <p className='pp-3'>
                        <ul>
                            <li>Take advantage of NVXO's secure key vault, login features, and digital wallet to manage your assets effectively.</li>
                            <li>Generate passwords and keys directly on your mobile device for enhanced security.</li>
                            <li>Easily browse and connect to decentralized websites.</li>
                            <li>Control the personal information you share with sites, deciding what remains private.</li>
                        </ul>
                    </p>
                </Box>

                <Box mt={3}>
                    <p className='pp-3'>
                        For beginners, we offer full support to ensure a smooth setup process, including the option to import your existing wallet.
                    </p>
                </Box>

            </Container>
        </>
    );
}

export default About;
